export default __webpack_public_path__ + "static/media/7d.948c774d.png";